import directives from './module';

class MoreTextCtrl {
    size: number;
    text: string;
    smallText: string;
    showAll: boolean;
    filterLinky: Function;
    safeText: string;

    constructor(private $filter: angular.IFilterService) {
    }

    $onChanges() {
        if (!this.text) return;

        this.filterLinky = this.$filter<Function>('linky');
        this.safeText    = this.filterBlank(this.text);

        if (this.size >= this.text.length) {
            this.showAll = true;
        } else {
            const smallText = this.text.substr(0, this.size).trim() + '...';
            this.smallText  = this.filterBlank(smallText);
        }
    }

    filterBlank(text: string) {
        return this.filterLinky(text, '_blank');
    }

    toggleShow() {
        this.showAll = !this.showAll;
    }
}

directives.directive('moreText', () => ({
    restrict: 'E',
    scope: {},
    controller: MoreTextCtrl,
    controllerAs: 'moreTextCtrl',
    bindToController: {
        size: '@',
        text: '<'
    },
    templateUrl: require('more-text.html')
}));


// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/moreTextDirective.ts